module.exports = __webpack_public_path__ + "static/media/326523676_1680211019101196_3286133549734355548_n.6873c8a5.png";